const translatedProvinces = {
  Amajyepfo: 'south',
  Iburengerazuba: 'west',
  Amajyaruguru: 'north',
  Iburasirazuba: 'east',
  kigali: 'kigali',
};
export default province =>
  translatedProvinces[province] || province?.toLowerCase();
